module.exports = __webpack_public_path__ + "static/fonts/DejaVuSansMono-Bold.fb4ec87.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/shared-components/spreadsheet/kendoui/fonts/DejaVu/DejaVuSansMono-Bold.ttf?v=1.1
// module id = 1642
// module chunks = 28